import { render, staticRenderFns } from "./BillingIcon.vue?vue&type=template&id=6094d3fe&scoped=true&"
import script from "./BillingIcon.vue?vue&type=script&lang=ts&"
export * from "./BillingIcon.vue?vue&type=script&lang=ts&"
import style0 from "./BillingIcon.vue?vue&type=style&index=0&id=6094d3fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6094d3fe",
  null
  
)

export default component.exports